import { forwardRef, type Ref, type SVGProps } from "react";
const IconZoomInOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M14 14h4a1 1 0 0 0 0-2h-4V8a1 1 0 0 0-2 0v4H8a1 1 0 0 0 0 2h4v4a1 1 0 1 0 2 0z" />
    <path d="M29.71 28.29 21.45 20A11 11 0 1 0 20 21.45l8.25 8.26a1 1 0 0 0 1.42 0 1 1 0 0 0 .04-1.42M13 22a9 9 0 1 1 9-9 9 9 0 0 1-9 9" />
  </svg>
);
const ForwardRef = forwardRef(IconZoomInOutlineSVG);
ForwardRef.displayName = "IconZoomInOutline";
export { ForwardRef as IconZoomInOutline };
